export const GLOBAL_TOAST = {
  NETWORK_ERROR: 'Please try again',
};

export const REGISTER_TOAST = {
  TERM_AND_CONDITION: 'Please select terms and condition',
};

export const OTP_VERIFICATION_TOAST = {
  MESSAGE: 'Otp successfully sent',
};

export const EDIT_DETAILS_TOAST = {
  FORMAT_INVALID:
    'Invalid file format. Please upload a file in JPG, JPEG or PNG, PDF format.',
  SPACES_NOT_ALLOWED:
    'File Name Contains Spaces, Please remove spaces if any and try again.',
};

export const ANNOTATION_TOAST = {
  DATA_REMOVED: 'Data removed successfully !!',
  DATA_OVERRIDE: 'Data override successfully !!',
  DATA_CONFIRMED: 'Data confirmed successfully !!',
  DATA_CHANGED: 'Data changed successfully !!',
};

export const DOCUMENT_TOAST = {
  NO_RECORDS: 'No records found.',
  ALL_DOCUMENTS_DELETED: 'All documents deleted successfully',
  DOCUMENT_DELETED: 'Document deleted successfully',
  TAG_CREATED: 'NewTag created successfully !!',
  DOCUMENT_NOT_DELETED: 'Some documents not deleted.',
  PDF_SUPPORT: 'Please upload a one-page pdf file.',
  FORMAT_INVALID:
    'Invalid file format. Please upload a file in JPG, JPEG or PNG, PDF format.',
  FILE_SIZE_TOO_LARGE: 'File is too large, only files under 10MB are allowed.',
  SPACES_OR_SPECIAL_CHARS_NOT_ALLOWED:
    'File Name Contains Spaces or Special Characters, Please remove spaces if any and try again.',
};

export const FLOW_TOAST = {
  ALL_FLOW_DELETED: 'All Flows deleted successfully',
  FLOW_DELETED: 'Flow deleted successfully',
  FLOW_DELETED_ERROR: 'Error deleting flows',
};

export const PAYMENT_TOAST = {
  NO_RECORDS: 'No records found.',
};

export const USER_TOAST = {
  USER_DELETE: 'User Deleted Successfully.',
};

export const API_KEY_TOAST = {
  COPY_API_KEY: 'API Key copied successfully.',
};
